// removed by extract-text-webpack-plugin
module.exports = {"gray-container":"TechnicalBulletin-module-gray-container-s931j","grayContainer":"TechnicalBulletin-module-gray-container-s931j"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalBulletin/TechnicalBulletin.module.scss
// module id = 1294
// module chunks = 0